export const NEW_KEY = '__NEW__'
export const EMPTY_KEY = '__EMPTY__'
